/**
 * ReportsHarvestInspectionsPeopleTableRow
 */
import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
import TableHeadTableCell from '../../../../../../../../components/TableHeadTableCell';

export default class ReportsHarvestInspectionsPeopleTableRow extends React.PureComponent<
    *
> {
    render() {
        return (
            <Table.Header
                // HACK inline styles
                style={{
                    fontSize: 14
                }}
            >
                <Table.Row>
                    <TableHeadTableCell
                        label="First Name"
                        value="personFirstName"
                        namespace="people"
                    />
                    <TableHeadTableCell
                        label="Last Name"
                        value="personLastName"
                        namespace="people"
                    />
                    <TableHeadTableCell
                        label="# Inspections"
                        value="numberOfInspections"
                        namespace="people"
                    />
                    <TableHeadTableCell
                        label="Picker Faults"
                        value="pickerFaultPercentage"
                        namespace="people"
                        defaultSort="pickerFaultPercentage_descending"
                    />
                </Table.Row>
            </Table.Header>
        );
    }
}
